<script>
import { mapState } from 'vuex'
import { setFieldsFromUrlOrStorage } from "@/paths/helpers";
import { setDeviceFingerPrint } from "@/paths/helpers";

const MEDICARE_STEPS = {
  zip: {
    component: () => import('@/components/SharedSteps/Zip'),
    completed: false,
    customProps: {
      trackProgress: true
    },
    progress: 5,
  },
  leaveBehindAds: {
    component: () => import('@/components/SharedSteps/LeaveBehindAds'),
    completed: false,
    customProps: {
      page: 'medicare'
    },
  },
  coverageTypeMedicare: {
    component: () => import('@/components/MedicareSteps/CoverageTypeMedicare'),
    completed: false,
    customProps: {},
    progress: 8,
  },
  coverageTypeTypeOfMedicarePlan: {
    component: () => import('@/components/MedicareSteps/CoverageTypeTypeOfMedicarePlan'),
    completed: false,
    customProps: {},
    progress: 10,
  },
  supplementOrAdvantage: {
    component: () => import('@/components/MedicareSteps/SupplementOrAdvantage'),
    completed: false,
    customProps: {},
    progress: 15,
  },
  whatIsYourGender: {
    component: () => import('@/components/SharedSteps/WhatIsYourGender'),
    completed: false,
    customProps: {
      trackProgress: true
    },
    progress: 20,
  },
  tellUsAboutYourself: {
    component: () => import('@/components/SharedSteps/TellUsAboutYourself'),
    completed: false,
    customProps: {
      trackProgress: true
    },
    progress: 25,
  },
  whatIsYourAddress: {
    component: () => import('@/components/SharedSteps/WhatIsYourAddress'),
    completed: false,
    customProps: {
      trackProgress: true
    },
    progress: 30,
  },
  whatIsYourBirthdate: {
    component: () => import('@/components/SharedSteps/WhatIsYourBirthdate'),
    completed: false,
    customProps: {
      trackProgress: true
    },
    progress: 35,
  },

  // HEALTH PATH
  whatKindOfCoverage: {
    component: () => import('@/components/SharedSteps/WhatKindOfCoverage'),
    completed: false,
    customProps: {},
    progress: 40,
  },
  familySize: {
    component: () => import('@/components/SharedSteps/FamilySize'),
    completed: false,
    customProps: {},
    progress: 45,
  },
  annualHouseholdIncome: {
    component: () => import('@/components/SharedSteps/AnnualHouseholdIncome'),
    completed: false,
    customProps: {},
    progress: 50,
  },
  howWouldYouDescribeYourCredit: {
    component: () => import('@/components/SharedSteps/HowWouldYouDescribeYourCredit'),
    completed: false,
    customProps: {},
    progress: 55,
  },
  doYouUseAnyTobaccoProducts: {
    component: () => import('@/components/SharedSteps/DoYouUseAnyTobaccoProducts'),
    completed: false,
    customProps: {},
    progress: 60,
  },
  heightWithValidationNew: {
    component: () => import('@/components/SharedSteps/HeightWithValidationNew'),
    completed: false,
    customProps: {},
    progress: 65,
  },
  weight: {
    component: () => import('@/components/SharedSteps/Weight'),
    completed: false,
    customProps: {},
    progress: 70,
  },
  haveYouEverBeenDeniedCoverage: {
    component: () => import('@/components/SharedSteps/HaveYouEverBeenDeniedCoverage'),
    completed: false,
    customProps: {},
    progress: 73,
  },
  preExistingConditions: {
    component: () => import('@/components/SharedSteps/PreExistingConditions'),
    completed: false,
    customProps: {},
    progress: 77,
  },
  whichConditions: {
    component: () => import('@/components/SharedSteps/WhichConditions'),
    completed: false,
    customProps: {},
    progress: 80,
  },
  // Shared steps
  whatIsYourEmail: {
    component: () => import('@/components/SharedSteps/WhatIsYourEmail'),
    completed: false,
    customProps: {
      trackProgress: true,
      trackFailure: true
    },
    progress: 85
  },
  doYouHaveADisability: {
    component: () => import('@/components/SharedSteps/DoYouHaveADisability'),
    completed: false,
    customProps: {},
    progress: 90,
  },
  phoneNumber: {
    component: () => import('@/components/SharedSteps/PhoneNumber'),
    completed: false,
    customProps: {},
    progress: 94,
  },
  medicareFinalStep: {
    component: () => import('@/components/MedicareSteps/MedicareFinalStep'),
    completed: false,
    customProps: {},
    progress: 100,
  },
  healthFinalStep: {
    component: () => import('@/components/SharedSteps/HealthFinalStep'),
    completed: false,
    customProps: {
      trackProgress: true
    },
    progress: 100,
  }
}
export default {
  name: 'medicare-path',

  data() {
    return {}
  },

  computed: {
    ...mapState([
      'steps',
      'fields',
      'currentStep',
      'nextStep',
      'isLoading',
      'progress',
      'transactionIdIsNotReady',
    ]),
  },

  created() {
    window.loadJornayaLeadId('1708159f-ad21-22ba-c4d1-e0da55421406')
    this.$store.commit('SET_STEPS', MEDICARE_STEPS)
    this.init()
    this.hideProgressSteps = [
      'leaveBehindAds',
    ]
  },

  methods: {
    init() {
      setFieldsFromUrlOrStorage(this)
      setDeviceFingerPrint(this);
      this.prepareNextStep('startPath')
    },

    prepareNextStep(step) {
      this.$store.dispatch('medicare/prepareNextStep', step)
    },

    showThisStep() {
      window.scrollTo({top: 0, behavior: 'smooth'})
      this.$store.dispatch('showThisStep')
    }
  }
}
</script>

<template>
  <div>
    <section class="container is-max-desktop mt-5 px-5">
      <b-progress
        class="progressBar pt-6 pb-3"
        :class="{ 'is-hidden': hideProgressSteps.includes(currentStep) }"
        :value="progress" type="is-primary"
        size="is-medium"
      />
    </section>
    <div class="pt-6 pb-3">
      <div class="is-relative">
        <transition name="fade" mode="out-in">
          <component
            v-if="currentStep"
            key="realStep"
            :is="steps[currentStep].component"
            :custom-props="steps[currentStep].customProps"
            @next-step="prepareNextStep(currentStep)"
          />
        </transition>
        <b-loading
          v-if="!hideProgressSteps.includes(nextStep)"
          :active="isLoading || transactionIdIsNotReady"
          :is-full-page="false"
          :can-cancel="false"
        />
      </div>
      <component
        v-if="nextStep"
        key="prepareStep"
        :is="steps[nextStep].component"
        :custom-props="steps[nextStep].customProps"
        @show-this-step="showThisStep"
        @next-step="prepareNextStep(nextStep)"
        prepare
      />
    </div>
    <div
      class="footer-need-to-call"
      style="visibility: hidden;"
    >
      <h5 class="callUs has-text-centered pt-6 pb-6 mb-6 mx-5">Rather Speak To Someone Now? Call <span id="footer-phone-number"></span></h5>
    </div>
    <div class="container is-max-desktop is-flex is-justify-content-center">
      <figure class="image is-194x108">
        <img src="../assets/img/bluehea-640w.png">
      </figure>
      <figure class="image is-194x108">
        <img src="../assets/img/Humana-640w.png">
      </figure>
      <figure class="image is-194x108">
        <img src="../assets/img/Cigna1-679b11f1-640w.png">
      </figure>
      <figure class="image is-194x108">
        <img src="../assets/img/Aetnasite-640w.png">
      </figure>
    </div>
  </div>
</template>
